import {
  getBooleanHashCode1bbj3u6b3v0a7 as getBooleanHashCode,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForClassbxx6q50dy2s7 as initMetadataForClass } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var ClientConfigClass;
function ClientConfig() {
  if (ClientConfigClass === VOID) {
    class $ {
      constructor(prereleaseMode, auth0ClientId, auth0Domain, basename, expressEnv, webpackPublicPath, websocketHost) {
        this.l7d_1 = prereleaseMode;
        this.m7d_1 = auth0ClientId;
        this.n7d_1 = auth0Domain;
        this.o7d_1 = basename;
        this.p7d_1 = expressEnv;
        this.q7d_1 = webpackPublicPath;
        this.r7d_1 = websocketHost;
      }
      toString() {
        return 'ClientConfig(prereleaseMode=' + this.l7d_1 + ', auth0ClientId=' + this.m7d_1 + ', auth0Domain=' + this.n7d_1 + ', basename=' + this.o7d_1 + ', expressEnv=' + this.p7d_1 + ', webpackPublicPath=' + this.q7d_1 + ', websocketHost=' + this.r7d_1 + ')';
      }
      hashCode() {
        var result = getBooleanHashCode(this.l7d_1);
        result = imul(result, 31) + getStringHashCode(this.m7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.n7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.o7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.p7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.q7d_1) | 0;
        result = imul(result, 31) + getStringHashCode(this.r7d_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof ClientConfig()))
          return false;
        if (!(this.l7d_1 === other.l7d_1))
          return false;
        if (!(this.m7d_1 === other.m7d_1))
          return false;
        if (!(this.n7d_1 === other.n7d_1))
          return false;
        if (!(this.o7d_1 === other.o7d_1))
          return false;
        if (!(this.p7d_1 === other.p7d_1))
          return false;
        if (!(this.q7d_1 === other.q7d_1))
          return false;
        if (!(this.r7d_1 === other.r7d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'ClientConfig');
    ClientConfigClass = $;
  }
  return ClientConfigClass;
}
//region block: exports
export {
  ClientConfig as ClientConfig2mpft8d5d0hh3,
};
//endregion

//# sourceMappingURL=ClientConfig.mjs.map
